import React, { useCallback, useContext, useState, useEffect } from 'react';
import classNames from 'classnames';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { Button } from '@fluentui/react-components';
import { getUIMetrics } from '@bingads-webui-campaign/overview-cards-common';
import { cardDeviceId } from '@bingads-webui-campaign/fluent-page-consts';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getNavigationLevel } from '@bingads-webui-campaign/fluent-page-data';
import { DeviceDefaultCard } from './devices-default-card';
import { DeviceComparisonCard } from './devices-comparison-card';
import { ShimmerCard } from './shimmer-card';
import { Legend } from '../utils/device-legend';
import { DeviceCardProps, IScopeContext } from '../utils/types';
import { useData } from './use-data';
import { getStyles } from '../styles/devices-card';

export function DeviceCard(props: DeviceCardProps | null | undefined) {
  const { scope } = useContext(ScopeContext) as IScopeContext;
  const {
    dateRange, filter, i18n, getCardsConfig, sesId, perfMarkerUtils, allMetrics, initialSelectedMetrics, patchPreference, campaignType,
  } = props;

  const [uiMetrics] = useState(getUIMetrics(allMetrics, campaignType, cardDeviceId));

  const { willFetchData, willRender, done } = perfMarkerUtils;
  const { aggregatedData, isLoading } = useData({
    dateRange,
    filter,
    campaignType,
    getCardsConfig,
    willRender,
    willFetchData,
    done,
  });
  const styles = useDefaultStyles(getStyles);
  const hideCurrency = aggregatedData.AccountsHaveDifferentCurrencies;

  const onClick = useCallback(() => {
    scope.save('/campaign/vnext/devices');
  }, [scope]);

  if (isLoading) {
    return <ShimmerCard />;
  }

  const isComparisonScenario = dateRange.compared;
  const navigationLevel = getNavigationLevel(scope);
  const footerVisible = navigationLevel !== 'customer';

  return (
    <div className={classNames(styles.container, 'ba-device-card')}>
      <div>
        <Legend i18n={i18n} />
      </div>
      <div className={classNames(styles.chartContainer)}>
        {!isComparisonScenario && (
          <DeviceDefaultCard
            i18n={i18n}
            deviceData={aggregatedData}
            dateRange={dateRange}
            hideCurrency={hideCurrency}
            filter={filter}
            sesId={sesId}
            perfMarkerUtils={perfMarkerUtils}
            allMetrics={uiMetrics}
            initialSelectedMetrics={initialSelectedMetrics}
            patchPreference={patchPreference}
            footerVisible={footerVisible}
          />
        )}
        {isComparisonScenario && (
          <DeviceComparisonCard
            i18n={i18n}
            deviceData={aggregatedData}
            dateRange={dateRange}
            hideCurrency={hideCurrency}
            filter={filter}
            sesId={sesId}
            perfMarkerUtils={perfMarkerUtils}
            allMetrics={uiMetrics}
            initialSelectedMetrics={initialSelectedMetrics}
            patchPreference={patchPreference}
            footerVisible={footerVisible}
          />
        )}
      </div>
      {footerVisible && (
        <div className={classNames(styles.footer, 'footer')}>
          <Button className="action-button" onClick={onClick}>
            {i18n.getString(_TL_('View devices'))}
          </Button>
        </div>
      )}
    </div>
  );
}
